import React from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

const LogoMark = () => {
  const navigate = useNavigate();

  return (
    <Box
      component="img"
      src="/images/short_logo_circle.png"
      alt="CakeyHand"
      onClick={() => navigate("/")}
      sx={{
        height: 40,
        cursor: "pointer",
        display: "block",
      }}
    />
  );
};

export default LogoMark;
